// App main roles
export const Roles = {
  worker: 'worker',
  employer: 'employer',
  visitor: 'visitor'
};
